<template>
    <div>
        <Header />
        <div class="index">
            <ul>
                <li><router-link to="/deliver-cert/VEpKSmpLN3pjRDJkU2xmMCtIODFGMDhjVHVNaE90L3dJdVQrN2R5NVlYUT0%3D">Giftiel 배송신청</router-link></li>
                <!-- 배송조회 확인용 -->
                <!-- <li><router-link to="/deliver-cert/H2gVYzN528hoNSyTKddBopnDH1OGIMVYFKisJuQEkG8=">Giftiel 배송신청</router-link></li> -->
                <li><router-link to="/information/6gQd0h6NlwfQoJAkMjojRcCVK39wEcNp3IrmOvXS7LI=">이용안내</router-link></li>
                <li><router-link to="/delivery-search/6gQd0h6NlwfQoJAkMjojRcCVK39wEcNp3IrmOvXS7LI=">배송조회</router-link></li>
                <li><router-link to="/se/6gQd0h6NlwfQoJAkMjojRcCVK39wEcNp3IrmOvXS7LI=">잔액조회</router-link></li>
            </ul>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import Header from '@/components/Header';
 
export default {
  name: "Index",
  components: {
    Header
  }
};
</script>

<style scoped lang='scss'>

@import '@/assets/styles/mixin.scss';
.index{
    h2{
        font-size: 20px;
        font-weight: bold;
        margin-bottom:40px;
    }
    padding: 30px;
    li{
        margin: 0 0 20px 0;
        a{
            font-size: 20px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/Index.vue